export default function select2Query($timeout) {
  return {
    queryTax() {
      const config = {
        minimumInputLength: 1,
        ajax: {
          type: 'GET',
          url: `${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/querySaleNameByUserId`,
          dataType: 'json',
          data(term) {
            return {
              companyName: term,
              accessToken: localStorage.getItem('id_token'),
            }
          },
          results(data, page) {
            //   select必须字段id和title
            data.value.forEach(function (el, index) {
              el.title = el.companyName
              //   el.id = index
            })
            return { results: data.value }
          },
        },
        formatResult(data) {
          return data.title
        },
        formatSelection(data) {
          return data.title
        },
      }
      return config
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/select2/select2Factory.js